import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatNativeDateModule } from "@angular/material/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { MatCheckboxModule } from "@angular/material/checkbox";
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";

import { MatDialogModule } from "@angular/material/dialog";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatRadioModule } from "@angular/material/radio";

import { LoginComponent } from "./login/login.component";
import { PatientsComponent } from "./patients/patients.component";
import { BottombarComponent } from "./bottombar/bottombar.component";
import { PatdetailsComponent } from "./patdetails/patdetails.component";

import { DocpanelComponent } from "./docpanel/docpanel.component";
import { TotpboxComponent } from "./totpbox/totpbox.component";

import { NgChartsModule } from "ng2-charts";

import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AutotextComponent } from "./autotext/autotext.component";
import { AutotextRowComponent } from "./autotext-row/autotext-row.component";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule } from "@angular/material/table";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatMenuModule } from "@angular/material/menu";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import {  MomentDateAdapter,  MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

import { GenradioComponent } from "./genradio/genradio.component";

import { InterceptorService } from "./interceptor.service";
import { CommerrorComponent } from "./commerror/commerror.component";

import { LoginboxComponent } from "./loginbox/loginbox.component";

import { AngularEditorModule } from "@kolkov/angular-editor";

import { GeninputComponent } from "./geninput/geninput.component";

import { MapPipe } from "./pipes/map.pipe";
import { FilterPipe } from "./pipes/filter.pipe";
import { SetPipe } from "./pipes/set.pipe";
import { ToArrayPipe } from "./pipes/to-array.pipe";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatProgressBarModule } from "@angular/material/progress-bar";

import { MatSelectModule } from "@angular/material/select";

import { UniqueAutoIndexPipe } from "./pipes/unique-auto-index.pipe";
import { SortCreationTimePipe } from "./pipes/sort-creation-time.pipe";

import { WeeksDaysPipe } from "./pipes/weeks-days.pipe";
import { UniqueExamsPipe } from "./pipes/unique-exams.pipe";
import { DatePipe } from "@angular/common";
import { FullCalendarModule } from "@fullcalendar/angular";
import { AppointmentsGeneralComponent } from "./appointments-general/appointments-general.component";
import { AppointmentComponent } from "./appointment/appointment.component";
import { MatStepperModule } from "@angular/material/stepper";
import { BlockComponent } from "./block/block.component";
import { BarComponent } from "./bar/bar.component";
import { LegendComponent } from "./legend/legend.component";
import { PatientInfoComponent } from "./patient-info/patient-info.component";
import { SortByDateTimePipe } from "./pipes/sort-by-date-time.pipe";
import { UserSettingsComponent } from "./user-settings/user-settings.component";
import { ExamsNamesComponent } from "./exams-names/exams-names.component";
import { ActivityHoursComponent } from "./activity-hours/activity-hours.component";
import { SearchComponent } from "./search/search.component";
import { NavComponent } from "./nav/nav.component";
import { BillingsComponent } from "./billings/billings.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { PrintAppointmentsComponent } from "./print-appointments/print-appointments.component";
import { SmsSettingsComponent } from "./sms-settings/sms-settings.component";
import { AppointmentSetupComponent } from "./appointment-setup/appointment-setup.component";
import { BookingComponent } from "./booking/booking.component";
import { MatCardModule } from "@angular/material/card";
import { NativeDateAdapter } from "@angular/material/core";
import { SortExamTypesPipe } from "./sort-exam-types.pipe";
import { TranslateDatePipe } from "./translate-date.pipe";
import { AppointmentsSetupNavComponent } from "./appointments-setup-nav/appointments-setup-nav.component";
import { AppointmentsSetupByRoomComponent } from "./appointments-setup-by-room/appointments-setup-by-room.component";
import { BookingNavComponent } from "./booking-nav/booking-nav.component";
import { BookingByRoomComponent } from "./booking-by-room/booking-by-room.component";
import { UniqueSlotsPipe } from "./pipes/unique-slots.pipe";
import { SortSlotsPipe } from "./pipes/sort-slots.pipe";
import { FilterExamsPipe } from "./filter-exams.pipe";
import { ApptsByRoomGynComponent } from "./appts-by-room-gyn/appts-by-room-gyn.component";
import { ExitConfirmationComponent } from './exit-confirmation/exit-confirmation.component';
import { QuestionnaireComponent } from "./questionnaire/questionnaire.component";
import { QuestionFieldComponent } from "./questionnaire/question-field/question-field.component";
import { SignaturePadComponent } from "./signature-pad/signature-pad.component";
import { WelcomeComponent } from "./welcome/welcome.component";
import { CardReaderComponent } from "./card-reader/card-reader.component";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
@NgModule({ declarations: [
        AppComponent,
        LoginComponent,
        PatientsComponent,
        BottombarComponent,
        PatdetailsComponent,
        DocpanelComponent,
        AutotextComponent,
        AutotextRowComponent,
        GenradioComponent,
        CommerrorComponent,
        LoginboxComponent,
        GeninputComponent,
        MapPipe,
        FilterPipe,
        SetPipe,
        ToArrayPipe,
        UniqueAutoIndexPipe,
        SortCreationTimePipe,
        TotpboxComponent,
        WeeksDaysPipe,
        UniqueExamsPipe,
        AppointmentsGeneralComponent,
        AppointmentComponent,
        BlockComponent,
        BarComponent,
        LegendComponent,
        PatientInfoComponent,
        SortByDateTimePipe,
        UserSettingsComponent,
        ExamsNamesComponent,
        ActivityHoursComponent,
        SearchComponent,
        NavComponent,
        BillingsComponent,
        PrintAppointmentsComponent,
        SmsSettingsComponent,
        AppointmentSetupComponent,
        BookingComponent,
        SortExamTypesPipe,
        TranslateDatePipe,
        AppointmentsSetupNavComponent,
        AppointmentsSetupByRoomComponent,
        BookingNavComponent,
        BookingByRoomComponent,
        UniqueSlotsPipe,
        SortSlotsPipe,
        FilterExamsPipe,
        ApptsByRoomGynComponent,
        ExitConfirmationComponent,
        QuestionnaireComponent,
        QuestionFieldComponent,
        SignaturePadComponent,
        WelcomeComponent,
        CardReaderComponent,
    ],
    exports: [],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        NgChartsModule,
        MatDatepickerModule,
        MatTableModule,
        MatIconModule,
        MatMomentDateModule,
        MatTooltipModule,
        MatMenuModule,
        MatDialogModule,
        MatCheckboxModule,
        AngularEditorModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatInputModule,
        MatExpansionModule,
        MatSelectModule,
        MatButtonToggleModule,
        MatRadioModule,
        FullCalendarModule,
        MatStepperModule,
        DragDropModule,
        MatNativeDateModule,
        MatCardModule,
        MatDatepickerModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        })], providers: [
        MatDatepickerModule,
        MatTooltipModule,
        UniqueExamsPipe,
        DatePipe,
        NativeDateAdapter,
        { provide: MAT_DATE_LOCALE, useValue: "he-IL" },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
